import { identity } from 'lodash-es';
import { MIXPANEL_PROXY_SERVICE_BASEURL } from 'config';
import ServiceFactory, { returnVoid } from 'services/ServiceFactory';
import { MIXPANEL_FORWARD_EVENT_PATH } from './constants';
import { ForwardedMixpanelEvent } from './types';

const serviceFactory = new ServiceFactory(MIXPANEL_PROXY_SERVICE_BASEURL);

export const forwardMixpanelEvent = serviceFactory.createPostEndpoint(
  MIXPANEL_FORWARD_EVENT_PATH,
)<ForwardedMixpanelEvent, void>({ data: identity, select: returnVoid() });
